import PicklistMetadata from "../PicklistMetadata";

// Bounded picklist of ALL company Work Groups (display = Name, value = USID), sourced from the
// WorkGroup EC (t5/v1/work_groups), realm-scoped. Used by the "Add Shared Work Group" membership
// picker on the term Stewardship/Visibility tab — lists every company work group (unlike the
// memberships-only "WorkGroup" picklist).
class WorkGroupSharedPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "WorkGroupShared";
        this.bounded = true;
        this.enterpriseComponent = "WorkGroup";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.useRealm = false;
        this.sortSpecification = [{"SortAttribute": "Name", "Direction": "DESC"}];
        this.static = false;
        this.typeField = "Name";
        this.typeValue = "USID";
        this.allowNoSelection = false;
    }
}

export default WorkGroupSharedPicklistMetadata;
